(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sizden-gelenler-carousel"] && !Shopify.designMode) return;
  try {
    
  class CustomerCarouselV2 extends HTMLElement {
    constructor() {
      super();
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      
      this.originalCount = this.track ? this.track.querySelectorAll('[data-slide]').length : 0;
      this.isJumping = false; // Geri bildirim döngüsünü engellemek için bayrak

      if (!this.viewport || !this.track || this.originalCount === 0) return;

      this.setupInfinite();
      this.bind();
      this.updateArrows();
      
    }

    get gap() {
      const cs = getComputedStyle(this.track);
      return parseFloat(cs.gap || cs.columnGap || '16');
    }
    get slideW() {
      const s = this.track.querySelector('[data-slide]');
      return s ? s.getBoundingClientRect().width : this.viewport.clientWidth;
    }
    get originalW() { // toplam orijinal içerik genişliği
      return Math.max(1, this.originalCount) * (this.slideW + this.gap) - this.gap;
    }

    normalizePosition() {
      if (this.originalCount <= 1) return;
      
      const pos = this.viewport.scrollLeft;
      const ow = this.originalW;
      const leftEdge = ow * 0.1;
      const rightEdge = ow * 1.9;
      
      let newPos = pos;
      if (pos < leftEdge) {
        newPos = pos + ow;
      } else if (pos > rightEdge) {
        newPos = pos - ow;
      }

      if (newPos !== pos) {
        this.isJumping = true;
        this.viewport.style.scrollBehavior = 'auto'; // Yumuşak kaydırmayı anlık olarak kapat
        this.viewport.scrollLeft = newPos; // Anında atla
        this.viewport.style.scrollBehavior = 'smooth'; // Tekrar aç
        
        // Tarayıcının atlamayı işlemesi için kısa bir gecikme sonrası bayrağı sıfırla
        setTimeout(() => {
          this.isJumping = false;
        }, 50);
      }
    }

    setupInfinite() {
      if (this.originalCount === 1) return; // tek slaytta klonlama yok
      const slides = Array.from(this.track.children);
      const clonesBefore = slides.map(n => n.cloneNode(true));
      const clonesAfter  = slides.map(n => n.cloneNode(true));
      clonesBefore.forEach(c => c.setAttribute('aria-hidden', 'true'));
      clonesAfter.forEach(c => c.setAttribute('aria-hidden', 'true'));
      this.track.prepend(...clonesBefore);
      this.track.append(...clonesAfter);
      
      // İlk pozisyonu ayarlarken anlık (auto) olmalı
      requestAnimationFrame(() => { 
        this.viewport.style.scrollBehavior = 'auto';
        this.viewport.scrollLeft = this.originalW; 
        this.viewport.style.scrollBehavior = 'smooth';
      });
    }

    bind() {
      // Eğer oklar markup'ta yoksa dinamik ekle
      if (!this.prevBtn || !this.nextBtn) {
        const wrap = document.createElement('div');
        wrap.className = 'ccv2-arrows';
        wrap.innerHTML = `
          <button class="ccv2-arrow ccv2-arrow--prev" data-prev aria-label="Önceki">
            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          <button class="ccv2-arrow ccv2-arrow--next" data-next aria-label="Sonraki">
            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>`;
        this.appendChild(wrap);
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
      }
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollBy(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollBy(1));

      // Klavye ile oklar (section fokuslandığında)
      const section = this.closest('section') || this;
      section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.scrollBy(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.scrollBy(1); }
      });

      // Sonsuz döngü için sarma
      this.viewport.addEventListener('scroll', () => this.onScrollLoop());
      window.addEventListener('resize', () => this.onResize());
    }

    onResize() {
      // Yeniden boyutlandırmada pozisyonu anlık olarak düzelt
      this.viewport.style.scrollBehavior = 'auto';
      this.normalizePosition();
      this.updateArrows();
      this.viewport.style.scrollBehavior = 'smooth';
    }

    onScrollLoop() {
      // Eğer 'isJumping' bayrağı aktifse (yani programatik atlama yapılıyorsa) bu fonksiyonu çalıştırma
      if (this.isJumping || this.originalCount <= 1) return;
      this.normalizePosition();
      this.updateArrows();
    }

    scrollBy(steps = 1) {
      const delta = steps * (this.slideW + this.gap);
      this.viewport.scrollBy({ left: delta, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevBtn || !this.nextBtn) return;
      const disabled = this.originalCount <= 1;
      this.prevBtn.disabled = disabled;
      this.nextBtn.disabled = disabled;
    }
    
  }

  if (!customElements.get('customer-carousel-v2')) {
    customElements.define('customer-carousel-v2', CustomerCarouselV2);
  }

  } catch(e) { console.error(e); }
})();
})();
